import React from 'react';

const GenerationSVG = ({
  fill
}) => (
  <svg width="90px" height="46px" viewBox="301 83 90 46">
    <path d="M380.491831,128 L391,128 C391,103.147186 370.852814,83 346,83 C321.147186,83 301,103.147186 301,128 L313.008169,128 C313.407018,109.706742 328.361037,95 346.75,95 C365.138963,95 380.092982,109.706742 380.491831,128 Z" fill={fill}></path>
  </svg>
)

export default GenerationSVG;


// WEBPACK FOOTER //
// ./src/assets/svg/generation.js